import message from "../../../messages/gift-user-register";

const validateStartDate = (startDate, endDate) => {
  const dateNowNumber = new Date().getTime();
  const startDateNumber = new Date(startDate).getTime();

  if (dateNowNumber >= startDateNumber) {
    return message.START_DATE_LOWER_THAN_CURRENT_DATE;
  }

  const endDateNumber = new Date(endDate).getTime();

  if (endDateNumber <= startDateNumber) {
    return message.END_DATE_LOWER_THAN_START_DATE;
  }

  return true;
};

const validateFormAddGiftUserRegister = (data) => {
  const resultValidateStartDate = validateStartDate(
    data.start_date,
    data.end_date
  );
  if (resultValidateStartDate != true) {
    return resultValidateStartDate;
  }

  return true;
};

export default validateFormAddGiftUserRegister;
